import { __decorate } from "tslib";
import { id_netscapeCertExtension } from "./object_identifiers";
import { AsnType, AsnTypeTypes, AsnPropTypes, AsnProp } from "@peculiar/asn1-schema";
export const id_netscapeCaRevocationUrl = `${id_netscapeCertExtension}.4`;
let NetscapeCaRevocationUrl = class NetscapeCaRevocationUrl {
    constructor(value) {
        this.value = "";
        if (value) {
            this.value = value;
        }
    }
};
__decorate([
    AsnProp({ type: AsnPropTypes.IA5String })
], NetscapeCaRevocationUrl.prototype, "value", void 0);
NetscapeCaRevocationUrl = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], NetscapeCaRevocationUrl);
export { NetscapeCaRevocationUrl };
